import Domain from "./domain";
export default {
  methods: {
    getWwcc: async function() {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "customer/wwcc/details?page=0&perpage=10000",
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getWwccById: async function(id) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "customer/wwcc/details/" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postWwcc: async function(obj) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/wwcc/status",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    uploadWWCCCardImage: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "customer/wwcc/image",
          obj,
          Domain.APP_HEADER_FORM_DATA
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
